import React from 'react';

const TCexpired: React.FC = () => (
  <p className="m-auto text-lg">Sorry, this link is expired.</p>
);
export default TCexpired;
